export const blueColor = "#0081C8";

export const anchor = {
    color: blueColor,
    "&:active": {
        color: "#0081C8"
    },
    "&:hover": {
        color: "#7E8186"
    }
}